import { render, staticRenderFns } from "./DataSet.vue?vue&type=template&id=17d71926&scoped=true&"
import script from "./DataSet.vue?vue&type=script&lang=js&"
export * from "./DataSet.vue?vue&type=script&lang=js&"
import style0 from "./DataSet.vue?vue&type=style&index=0&id=17d71926&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d71926",
  null
  
)

export default component.exports